import { useEffect } from "react";

function setMeta(attr, attrValue, content) {
  let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, ogTitle, ogDescription, ogImage, ogType, canonical }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    if (ogTitle || title) setMeta("property", "og:title", ogTitle || title);
    if (ogDescription || description) setMeta("property", "og:description", ogDescription || description);
    if (ogImage) setMeta("property", "og:image", ogImage);
    if (ogType) setMeta("property", "og:type", ogType);
    if (canonical) setLink("canonical", canonical);
  }, [title, description, ogTitle, ogDescription, ogImage, ogType, canonical]);
}
